import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SurveyJob } from 'src/app/shared/survey-data-services/survey-job';
import { User } from 'src/app/shared/user/user';

@Component({
    selector: 'job-assigned-user',
    templateUrl: './job-assigned-user.component.html'
})
export class JobAssignedUserComponent implements OnChanges {
    @Input() job: SurveyJob;
    @Input() canEdit: boolean = false;

    @Output() delete = new EventEmitter<User>();

    constructor(private translate: TranslateService) {
        this.buttonTooltip = this.translate.instant('TC.Common.Delete');
    }

    assignedUser: User;
    assignedUserName: string = 'N/A';
    buttonTooltip: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.job && changes.job.currentValue) {
            this.determineAssignedUserName();
        }
    }

    deleteAction() {
        this.delete.emit(this.assignedUser);
    }

    determineAssignedUserName(): void {
        if (!this.job || !Array.isArray(this.job.assignees) || this.job.assignees.length === 0) {
            this.assignedUserName = 'N/A';
            return;
        }

        if (this.job.assignees.length === 1) {
            this.assignedUserName = this.job.assignees[0].name;
            this.assignedUser = this.job.assignees[0];
            return;
        }

        // Multiple assignees
        const lastModifiedUserId = this.job.modifiedBy?.id;
        const lastModifiedUser = this.job.assignees.find(user => user.id === lastModifiedUserId);
        if (lastModifiedUser) {
            this.assignedUserName = lastModifiedUser.name;
            this.assignedUser = lastModifiedUser;
        } else {
            this.assignedUserName = this.job.assignees[this.job.assignees.length - 1].name;
            this.assignedUser = this.job.assignees[this.job.assignees.length - 1];
        }
    }
}
